import { DataCard } from '../../../components/DashboardCard';
import { useLateCheckoutAnalytics } from '../../../hooks/Dashboard/useLateCheckoutAnalytics';

export const LateCheckoutsCard = (props: DashboardCardProps) => {
  const { theme } = props;
  const { lateCheckoutAnalytics, getLateCheckoutAnalytics, loading } =
    useLateCheckoutAnalytics();

  return (
    <DataCard
      data={lateCheckoutAnalytics}
      title="Late Checkouts"
      views={['list', 'graph', 'pie']}
      columns={[
        { name: 'Time', dataKey: 'id' },
        { name: '#', dataKey: 'value', isNumeric: true },
        { name: 'Revenue', dataKey: 'revenue', isNumeric: true },
      ]}
      leftLabel="Count"
      bottomLabel="Time"
      loading={loading}
      refresh
      onRefresh={getLateCheckoutAnalytics}
      enableTimespan
      theme={theme}
    />
  );
};
